// src/AudioSpectrum/effects/particles.js
import { getHSLColor } from '../colorUtils.js';

export const drawParticles = (ctx, frequencyData, width, height, particlesRef) => {
  ctx.clearRect(0, 0, width, height);
  
  // 새로운 파티클 생성
  for (let i = 0; i < frequencyData.length; i += 8) {
    const value = frequencyData[i];
    if (value > 100) {
      particlesRef.current.push({
        x: (i / frequencyData.length) * width,
        y: height,
        vx: (Math.random() - 0.5) * 4,
        vy: -(value / 255) * 8 - 2,
        life: 1.0,
        decay: 0.02,
        color: getHSLColor((i / frequencyData.length) * 360, 100, 50),
        size: (value / 255) * 4 + 1
      });
    }
  }
  
  // 파티클 업데이트 및 그리기
  particlesRef.current = particlesRef.current.filter(particle => {
    particle.x += particle.vx;
    particle.y += particle.vy;
    particle.vy += 0.1; // 중력
    particle.life -= particle.decay;
    
    if (particle.life > 0) {
      ctx.globalAlpha = particle.life;
      ctx.fillStyle = particle.color;
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      ctx.fill();
      
      return true;
    }
    return false;
  });
  
  ctx.globalAlpha = 1.0;
};